module.exports = __webpack_public_path__ + "img/qycg.e27909b.png";